import { Injectable, inject } from '@angular/core'
import { TicketService } from '@solidgroup-agency/ticket-system/services'
import { UserService } from '../core/services/user.service'

type TicketListOptions = Parameters<TicketService['getTicketsPaginated']>[1]
type WatchOptions = Parameters<TicketService['watchActiveTicketIds']>[0]

/**
 * Ticket-Service mit Rollenbeschränkung (#1277): Mitarbeiter und Teamleitung dürfen
 * laut Rules nur Tickets lesen, die ihnen zugewiesen sind. Eine Listen-Query ohne
 * `assignee.uid`-Filter würde komplett abgelehnt. Die Bibliothek bietet den Filter
 * nur als umschaltbares „Meine Tickets" — hier wird er für diese Rollen erzwungen.
 */
@Injectable({ providedIn: 'root' })
export class AwoTicketService extends TicketService {
  private readonly userService = inject(UserService)

  private get onlyOwnTickets(): boolean {
    return this.userService.isEmployee() || this.userService.isTeamlead()
  }

  override getTicketsPaginated(showClosed = false, options?: TicketListOptions) {
    return this.onlyOwnTickets
      ? this.getMyTicketsPaginated(options)
      : super.getTicketsPaginated(showClosed, options)
  }

  override watchActiveTicketIds(options: WatchOptions, callback: (ids: string[]) => void) {
    return super.watchActiveTicketIds(
      this.onlyOwnTickets ? { ...options, onlyMine: true } : options,
      callback,
    )
  }
}
